// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file profile_type.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file profile_type.proto.
 */
export const file_profile_type: GenFile = /*@__PURE__*/
  fileDesc("ChJwcm9maWxlX3R5cGUucHJvdG8SBmRvbWFpbiriAQoLUHJvZmlsZVR5cGUSGAoUUFJPRklMRV9UWVBFX1VOS05PV04QABIcChhQUk9GSUxFX1RZUEVfUFJFRkVSRU5DRVMQARIWChJQUk9GSUxFX1RZUEVfSU5CT1gQAhIYChRQUk9GSUxFX1RZUEVfUFJJVkFURRADEh0KGVBST0ZJTEVfVFlQRV9PUkdBTklaQVRJT04QBBIjCh9QUk9GSUxFX1RZUEVfT1JHQU5JWkFUSU9OX0FETUlOEAUSJQohUFJPRklMRV9UWVBFX09SR0FOSVpBVElPTl9TRVJWSUNFEAZCMFouZ2l0bGFiLmNvbS9jb3RlY2hkZS9tb25vcmVwby9iYWNrZW5kL2RvbWFpbi9wYmIGcHJvdG8z");

/**
 * @generated from enum domain.ProfileType
 */
export enum ProfileType {
  /**
   * used as default value, see https://developers.google.com/protocol-buffers/docs/proto3#enum
   *
   * @generated from enum value: PROFILE_TYPE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: PROFILE_TYPE_PREFERENCES = 1;
   */
  PREFERENCES = 1,

  /**
   * @generated from enum value: PROFILE_TYPE_INBOX = 2;
   */
  INBOX = 2,

  /**
   * @generated from enum value: PROFILE_TYPE_PRIVATE = 3;
   */
  PRIVATE = 3,

  /**
   * @generated from enum value: PROFILE_TYPE_ORGANIZATION = 4;
   */
  ORGANIZATION = 4,

  /**
   * @generated from enum value: PROFILE_TYPE_ORGANIZATION_ADMIN = 5;
   */
  ORGANIZATION_ADMIN = 5,

  /**
   * @generated from enum value: PROFILE_TYPE_ORGANIZATION_SERVICE = 6;
   */
  ORGANIZATION_SERVICE = 6,
}

/**
 * Describes the enum domain.ProfileType.
 */
export const ProfileTypeSchema: GenEnum<ProfileType> = /*@__PURE__*/
  enumDesc(file_profile_type, 0);

